import React from 'react';
import styles from './CEOVideoSection.module.css';

function PhoneIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
    );
}

function ClockIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    );
}

function UserIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </svg>
    );
}

function CEOVideoSection({ videoUrl }) {
    return (
        <section className={styles.videoSection} id="ceo-video">
            <div className={styles.videoInner}>
                <div className={styles.videoLabel}>Paul Moss — CEO &amp; Co-Founder</div>
                <div className={styles.videoHead}>
                    <h2>From 90 lbs overweight<br />to founding TB2 Health</h2>
                    <p>
                        Paul shares his personal battle with weight, the moment GLP-1s changed everything,
                        and why he built a company to make this accessible for everyone.
                    </p>
                </div>

                <div className={styles.videoPlayer}>
                    {videoUrl ? (
                        <iframe
                            className={styles.videoIframe}
                            src={videoUrl}
                            title="Paul Moss Founder Story"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    ) : (
                        <div className={styles.videoPoster}>
                            <div className={styles.videoPosterBg} />
                            <button className={styles.videoPlayBtn} aria-label="Play Paul's story" disabled>
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <polygon points="5,3 19,12 5,21" />
                                </svg>
                            </button>
                            <div className={styles.videoPosterCaption}>
                                <strong>Paul Moss — Founder Story</strong>
                                <span>Video coming soon</span>
                            </div>
                        </div>
                    )}
                    <div className={styles.videoDuration}>13:25</div>
                </div>

                <div className={styles.videoMeta}>
                    <div className={styles.videoMetaItem}>
                        <ClockIcon />
                        13 minutes
                    </div>
                    <div className={styles.videoMetaItem}>
                        <UserIcon />
                        Paul Moss, CEO &amp; Co-Founder
                    </div>
                    <div className={styles.videoMetaItem}>
                        <PhoneIcon />
                        650.759.6343
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CEOVideoSection;
